import React, { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import MonthPicker from './components/MonthPicker';
import EmployeeReportTable from './components/EmployeeReportTable';
import { useApiHandler } from '../../utils/apiHandler';
import BaseLayout from '../../layouts/BaseLayout';
import { exportToExcel } from './components/ExcelExport';
import LoadingSpinner from './components/LoadingSpinner';

function EmployeeReport() {
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(5, 7)); // Store month as MM
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Store year as YYYY
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const apiHandler = useApiHandler();

  // Function to fetch report data
  const fetchReportData = async (month, year) => {
    setLoading(true);
    try {
      const response = await apiHandler.post('/admin/get-employeeReport', {
        month,
        year,
      });
      if (response.data.success) {
        setReportData(response.data.data?.employeesWorkSessions);
      }
    } catch (error) {
      console.error('Error fetching report:', error);
    } finally {
      setLoading(false);
    }
  };

  // Handle month and year change
  const handleMonthChange = (month, year) => {
    setSelectedMonth(month);
    setSelectedYear(year);
  };

  // Handle generating the report
  const handleGenerateReport = () => {
    console.log(selectedMonth, selectedYear)
    fetchReportData(selectedMonth, selectedYear);
  };

  // Handle exporting data to Excel
  const handleExport = () => {
    exportToExcel(reportData, `employee-report-${selectedYear}-${selectedMonth}`);
  };

  // Fetch report data when the component mounts or when the month/year changes
  useEffect(() => {
    if (selectedMonth && selectedYear) {
      fetchReportData(selectedMonth, selectedYear);
    }
  }, [selectedMonth, selectedYear]);

  return (
    <BaseLayout>
      <div className="min-h-screen bg-gray-50 py-8 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-gray-900">Employee Work Report</h1>
              <div className="flex space-x-4">
                {/* Generate Report Button */}
                <button
                  onClick={handleGenerateReport}
                  disabled={loading}
                  className={`flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {loading ? (
                    <LoadingSpinner className="h-4 w-4 mr-2" />
                  ) : (
                    <span>Generate Report</span>
                  )}
                </button>

                {/* Export to Excel Button */}
                <button
                  onClick={handleExport}
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Export to Excel
                </button>
              </div>
            </div>

            <div className="mb-6">
              <MonthPicker
                
                onChange={handleMonthChange}
              />
            </div>

            {loading ? <LoadingSpinner /> : <EmployeeReportTable data={reportData} />}
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}

export default EmployeeReport;
